
import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import Hero from './components/Hero';
import ProductCategories from './components/ProductCategories';
import CTA from './components/CTA';

const Products = () => {
  useEffect(() => {
    // Update page title and meta description for products page
    document.title = 'Enterprise IT Products - ManageEngine, AutomMate, Zoho One | WOTECH';
    
    // Add meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Discover enterprise IT products including ManageEngine ITSM/ITOM solutions, AutomMate automation platform, and Zoho One business suite from WOTECH.');
    }

    // Add structured data for Product page
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "Enterprise IT Products",
      "description": "Comprehensive portfolio of enterprise IT products and solutions",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/products`,
      "mainEntity": {
        "@type": "ItemList",
        "name": "IT Product Categories",
        "itemListElement": [
          {
            "@type": "Product",
            "name": "ManageEngine Solutions",
            "description": "ITSM and ITOM solutions for enterprise IT management"
          },
          {
            "@type": "Product", 
            "name": "AutomMate Platform",
            "description": "Business process automation and RPA solutions"
          },
          {
            "@type": "Product",
            "name": "Zoho One Suite",
            "description": "Integrated business applications and CRM solutions"
          }
        ]
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Products",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/products`
          }
        ]
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <ProductCategories />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default Products;
